"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var AUTH0_USER_INFO_NAMESPACE = "https://hifieng.io/";
exports.parseTokenUserInfo = function (token) {
  var decodedToken = jwt_decode_1.default(token);
  var userInfo = {};
  if (decodedToken[AUTH0_USER_INFO_NAMESPACE + "userName"]) {
    userInfo.name = decodedToken[AUTH0_USER_INFO_NAMESPACE + "userName"];
  }
  return userInfo;
};